import React, { useEffect, useMemo, useState } from 'react'
import RecordsMessage from '../../components/RecordsMessage';
import Table from '../../components/Table';
import { useTable } from 'react-table';
import { capitalizeFirstLetters } from '../../features/ValueFormater';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown, faUser } from '@fortawesome/free-solid-svg-icons';
import { handleImageError } from '../../utils/functions';
import { useDispatch, useSelector } from 'react-redux';
import TableSelect from '../../components/TableSelect';
import EmployeeDetailsPopup from '../../components/Employees/EmployeeDetailsPopup';
import { setEmployeeDetails, setShowDeleteEmployeePopup, setShowEmployeeDetailsPopup } from '../../features/employeeSlice';
import useEmployeesApi from '../../api/EmployeesApi';
import UtcToLocal from '../../components/UtcToLocal';
import { setActionPayload, setActionType } from '../../features/authorizationSlice';
import { ACTION_TYPES } from '../../app/actionTypes';
import { useOutletContext } from 'react-router-dom';
import TableSkeleton from '../../components/skeletons/TableSkeleton';
import { setLoading } from '../../features/responseSlice';

function EmployeeTemplate () {

  const showEmployeeDetailsPopup = useSelector(state => state.employees.showEmployeeDetailsPopup);
  const [activeRowIndex, setActiveRowIndex] = useState(-1);
  const blockedEmployees = useSelector(state => state.employees.blockedEmployees);
  const employeesData = useSelector(state => state.employees.allEmployees)
  const [data, setData] = useState([]);

  const dispatch = useDispatch();
  const { GetEmployees, loading } = useEmployeesApi();

  const [ onOpenQrAfterGenerate ]  = useOutletContext();

  useEffect(() => {
    GetEmployees();
  }, [])

  const handleBlock = (employeeID, event) => {
    event.stopPropagation(); 

    const payload = {
        employeeID: employeeID
    };
    
    dispatch(setActionType(ACTION_TYPES.BLOCK_EMPLOYEE));
    dispatch(setActionPayload(payload));

    onOpenQrAfterGenerate();
};

  const options = {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    year: 'numeric'
};

useEffect(() => {
  if (Array.isArray(employeesData)) {
    const formattedData = employeesData.map(employee => ({
      EmployeeID: employee.id,
      UserImage: "Images/avatar.png",
      EmployeeName: employee.name,
      Position: employee.role,
      LastAccessDate: employee.lastLoginDate,
      PhoneNumber: employee.mobileNo,
      Email: employee.email, 
      isBlocked: employee.isBlocked,
    })); 
    setData(formattedData);
  }
}, [employeesData]);

const handleOpenModal = (row) => {
  
  if (row.original.Position !== "Arz") {
  dispatch(setEmployeeDetails({
    ...row.original,
    EmployeeID: row.original.EmployeeID,
  }));
  dispatch(setShowEmployeeDetailsPopup(true));
  dispatch(setShowDeleteEmployeePopup(false));
}};


const columns = useMemo(() => [
        {
          Header: "",
          accessor: "UserImage",
          Cell: ({ row, cell: {value}}) => {
            return (
              <div className='showmore'>
                  {row.original.UserImage ? (
                      <div className='row'>
                          <div className='col-1 avatar-employee p-0'>
                              <img 
                                  src={row.original.UserImage}
                                  alt='avatar'
                                  onError={handleImageError}
                                  className="avatar-employee"
                              />
                          </div>
                      </div>
                  ) : (
                      <div className="row-8">
                          <span className="me-2">
                              <FontAwesomeIcon icon={faUser} />
                          </span>
                      </div>
                  )}
              </div>
          )
       }
      },
      {
          Header: "Employee Name",
          accessor: "EmployeeName",
      },
      {
        Header: "",
        accessor: "details",
        Cell: ({ row }) => (
             <button className="showmore" onClick={() => setActiveRowIndex(row.index)}>
                <FontAwesomeIcon icon={faArrowDown} />
            </button>
           
        ),
      },
      {
          Header: "Position",
          accessor: "Position"
      },
      {
          Header: "Last Access Date",
          accessor: "LastAccessDate",
          Cell: ({cell: {value}}) => {
            return <UtcToLocal utcTimestamp={value} options={options}/>
        },
      },
      {
          Header: "Phone Number",
          accessor: "PhoneNumber"
      },
      {
          Header: "Email",
          accessor: "Email"
      },
      {
        Header: "Action",
        accessor: "block",
        Cell: ({ row }) => {
            const isBlocked = row.original.isBlocked;
            if (row.original.Position !== "Arz") {
                return (
                    <button
                        className={isBlocked ? 'unblock-btn' : 'block-btn'}
                        onClick={(event) => handleBlock(row.original.EmployeeID, event)}
                    >
                        {isBlocked ? 'Unblock' : 'Block'}
                    </button>
                );
            }
        },
    },
    ], [blockedEmployees]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({ columns, data: data });


  return (
    <div className='EmployeesTemplate'>
    
      <div className='table-container'>
        {
          loading ? (
            <TableSkeleton />
          ) : (
            <TableSelect
            headerGroups={headerGroups}
            page={rows}
            prepareRow={prepareRow}
            getTableProps={getTableProps}
            getTableBodyProps={getTableBodyProps}
            activeRowIndex={activeRowIndex}
            setActiveRowIndex={setActiveRowIndex}
            sort={true}
            handleOpenModal={handleOpenModal} 
            blockedEmployees={blockedEmployees}
        />
          )
        }
     
          </div>
          {showEmployeeDetailsPopup && 
              <EmployeeDetailsPopup />
          }
        
        </div>
  )
}


export default EmployeeTemplate;